import "core-js/modules/es6.function.name";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SideMenuItem from './side-menu-item.vue';
import CollapsedMenu from './collapsed-menu.vue';
import { getUnion } from '@/libs/tools';
import mixin from './mixin';
export default {
  name: 'SideMenu',
  mixins: [mixin],
  components: {
    SideMenuItem: SideMenuItem,
    CollapsedMenu: CollapsedMenu
  },
  props: {
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    collapsed: {
      type: Boolean
    },
    theme: {
      type: String,
      default: 'dark'
    },
    rootIconSize: {
      type: Number,
      default: 20
    },
    iconSize: {
      type: Number,
      default: 16
    },
    accordion: Boolean,
    activeName: {
      type: String,
      default: ''
    },
    openNames: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      openedNames: []
    };
  },
  methods: {
    handleSelect: function handleSelect(name) {
      this.$emit('on-select', name);
    },
    getOpenedNamesByActiveName: function getOpenedNamesByActiveName(name) {
      return this.$route.matched.map(function (item) {
        return item.name;
      }).filter(function (item) {
        return item !== name;
      });
    },
    updateOpenName: function updateOpenName(name) {
      if (name === this.$config.homeName) this.openedNames = [];else this.openedNames = this.getOpenedNamesByActiveName(name);
    }
  },
  computed: {
    textColor: function textColor() {
      return this.theme === 'dark' ? '#fff' : '#495060';
    }
  },
  watch: {
    activeName: function activeName(name) {
      if (this.accordion) this.openedNames = this.getOpenedNamesByActiveName(name);else this.openedNames = getUnion(this.openedNames, this.getOpenedNamesByActiveName(name));
    },
    openNames: function openNames(newNames) {
      this.openedNames = newNames;
    },
    openedNames: function openedNames() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs.menu.updateOpened();
      });
    }
  },
  mounted: function mounted() {
    this.openedNames = getUnion(this.openedNames, this.getOpenedNamesByActiveName(name));
  }
};